<template>
    <div>
        <Header />
        <Menu />

        <div class="container">
            <md-card>
                <md-card-content>
                    <md-field class="firstName">
                        <label for="first-name">Name</label>
                        <md-input v-model="name" name="first-name" id="first-name" autocomplete="name" />
                    </md-field>
                    <md-field class="subject">
                        <label for="subject">Subject</label>
                        <md-input v-model="subject" name="subject" id="subject" autocomplete="subject" />
                    </md-field>
                    <md-field>
                        <label>Message</label>
                        <md-textarea v-model="body" name="message" id="message" autocomplete="message"></md-textarea>
                    </md-field>
                </md-card-content>
                
                <div class="send-button">
                    <md-button :href="buildHref" class="md-raised md-primary">Send</md-button>
                </div>
            </md-card>

        </div>

        <Footer />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: '',
                subject: '',
                body: ''
            }
        },
        computed: {
            // a computed getter
            buildHref: function () {
            // `this` points to the vm instance
                return  encodeURI('mailto:contact@thoulessart.ca' +
                        '?subject=' + this.subject + ' - from: ' + this.name +
                        '&body=' + this.body)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~vue-material/dist/components/MdCard/index.css';
    @import '~vue-material/dist/components/MdField/index.css';
    @import '~vue-material/dist/components/MdButton/index.css';

    .md-card.md-theme-default {
        padding: 30px;
        background-color: #212121;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    }

    .md-field.md-theme-default.md-focused::before, .md-field.md-theme-default::after {
        background-color: rgba(255, 255, 255, 0.87);
    }

    .md-field.md-theme-default.md-focused label,
    .md-field.md-theme-default label,
    .md-field.md-theme-default.md-focused input,
    .md-field.md-theme-default input,
    .md-field.md-theme-default.md-focused textarea,
    .md-field.md-theme-default textarea {
        color: rgba(255, 255, 255, 0.87);
    }

    .md-field.md-theme-default.md-has-textarea:not(.md-autogrow):after {
        border-color: #fff;
    }

    .send-button {
        width: 100%;
        text-align: center;
        padding: 0 0 40px;
    }

    .md-button {
        background-color: rgb(68, 138, 255);
        color: #FFF;
    }
</style>